import _, { range } from 'lodash';
import pdfMake from 'pdfmake/build/pdfmake';
// import vfsFonts from 'pdfmake/build/vfs_fonts';
import vfsFonts from '../vfs_fonts2';
const maxProduct=20

export function  getBase64ImageFromURL(url) {
	return new Promise((resolve, reject) => {
	  var img = new Image();
	  img.setAttribute("crossOrigin", "anonymous");
	
	  img.onload = () => {
		var canvas = document.createElement("canvas");
		canvas.width = img.width;
		canvas.height = img.height;
	
		var ctx = canvas.getContext("2d");
		ctx.drawImage(img, 0, 0);
	
		var dataURL = canvas.toDataURL("image/png");
	
		resolve(dataURL);
	  };
	
	  img.onerror = error => {
		reject(error);
	  };
	
	  img.src = url+'?c='+Math.random();
	});
}

let urlLtd = 'https://ltd-dev-media.iste.org/logo/l_1000508_Screen%20Shot%202021-08-07%20at%201.30.42%20PM.png'
let urlChess='https://images.pexels.com/photos/209640/pexels-photo-209640.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=300'


async function getDemoIcon(){
  try{
	return await getBase64ImageFromURL('https://images.pexels.com/photos/209640/pexels-photo-209640.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=300' ) 
  } catch {
	return await getBase64ImageFromURL( '../images/no_image_sml.png')
  }
}

async function getProductIcon(url:string){
	try{
	   if (!!url)
	  	   return await getBase64ImageFromURL(url )
	   else
		   return await getBase64ImageFromURL( '../images/no_image_sml.png')
	} catch {
	  return await getBase64ImageFromURL( '../images/no_image_sml.png')
	}
  }

export default async function documentDefinition( products)  {
	const {vfs} = vfsFonts.pdfMake;
	pdfMake.vfs = vfs;

	pdfMake.fonts = {
		Montserrat:{
			normal: 'Montserrat-Regular.ttf',
			bold: 'Montserrat-Bold.ttf',
			italics: 'Montserrat-Italic.ttf',
			bolditalics: 'Montserrat-BoldItalic.ttf'
		}
	}
	let detailLines= (products) =>  {
		let count=-1
		let res=[]
		let productImageList=[]

		let widthProdNumeralWidth = 12
		let widthImage =60
		let widthName ='auto'
		let widthFillerBtwImage = 5
		

		_.take(products,  maxProduct).forEach(_ => {

			res.push(
				{   unbreakable:true,
					columns:[
					
					{'text': (++count)+1+'. ', bold:true, width:widthProdNumeralWidth} ,
					{'text':'', width:widthFillerBtwImage},

					{image: 'productIcon'+count, width:widthImage},
					{	
						stack:
						[
							{columns: 
								[
									{'text':'', width:widthFillerBtwImage},
									{'text': ' ', width: 5},
									{'text': _.name, width: widthName, bold:true, fontSize:14},
								],
							},
							{text:' ', lineHeight: 0.5}, 
						
							{columns:[
								// {'text': '', bold:true, width:(widthProdNumeralWidth+widthImage+ 2* widthFillerBtwImage)} ,
								{'text':'', width:widthFillerBtwImage},
								{'text': ' ', width: 5},
								{'text': 'by '+ _.organizationName, width:80 , style:'normal1'} ,
								{'text': '  |  ULTID: ', width:35, style:'gray1'},
								{'text':  _.ultid , width: 120, bold:true, style:'gray1'},
								{'text': '  |  Updated: '+ new Date(_.lastModificationTimestamp).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' } ) , width: widthName, style:'gray1'},
								
							]}
						],

					}
				]}
			)
			res.push( {text:' ', lineHeight: 2}, )
			res.push(
				{columns:[
					{'text': '', bold:true, width:(widthProdNumeralWidth+ widthFillerBtwImage)} ,
					{'text': _.publicDescription , width: 'auto', style:'normal1'},
				]}
			)
			res.push( {text:' ', lineHeight: 1}, )
			res.push( 
				{columns:[
					{'text': '', bold:true, width:(widthProdNumeralWidth+ widthFillerBtwImage)} ,
					{image:'grey_line', width:(530-widthProdNumeralWidth- widthFillerBtwImage)}

				]}
			)
			res.push( {text:' ', lineHeight: 1}, )
		});
		return(res)
	}

//   let imagesIconVfs = products.array.forEach((p, x) => {
	   
// 	  return {}['productIcon'+x] = await getProductIcon(!!p.image_url)
//  	 }
//   );


  const documentDefinition=  {
	    defaultStyle: {
			font:'Montserrat'
		},
  	    info: {
  			title: 'My List',
  			subject: 'subject of document',
  			keywords: 'keywords for document',
  		},
  		pageSize: 'LETTER',
  		pageOrientation: 'portrait',
  		content: [
  			{image: 'bannerImage', width:186, height:22},
  			{text:' ', lineHeight: 2},	
  			{text:'My List', bold:true, fontSize:14},
  			{text:' ', lineHeight: 0.5},	
  			{text: products.length+' items | Exported: ' + new Date().toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' } ), fontSize: 10, color:'#808A98'},
			{text:' ', lineHeight: 1},
			{image:'grey_line', width:530},
		
			{text:' ', lineHeight: 1},
			
  			...detailLines(products),
  		],
  
  		styles:{
  			normal1: {
  				fontSize:8,
  			},
			gray1: {
				fontSize:8,
				color:'#808A98'
			},
  
  		},
  		images: {
			// e.g. works with  : https://images.pexels.com/photos/209640/pexels-photo-209640.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=300


  			demoIcon:    await getDemoIcon(),
			bannerImage: await getBase64ImageFromURL( '../images/edtech-index.png'),
			grey_line:   await getBase64ImageFromURL( '../images/grey180_line.png'),

			// up to :	maxProduct
			productIcon0: await getProductIcon(safeUrl(products[0])),
			productIcon1: await getProductIcon(safeUrl(products[1])),
			productIcon2: await getProductIcon(safeUrl(products[2])),
			productIcon3: await getProductIcon(safeUrl(products[3])),
			productIcon4: await getProductIcon(safeUrl(products[4])),
			productIcon5: await getProductIcon(safeUrl(products[5])),
			productIcon6: await getProductIcon(safeUrl(products[6])),
			productIcon7: await getProductIcon(safeUrl(products[7])),
			productIcon8: await getProductIcon(safeUrl(products[8])),
			productIcon9: await getProductIcon(safeUrl(products[9])),

			productIcon10: await getProductIcon(safeUrl(products[10])),
			productIcon11: await getProductIcon(safeUrl(products[11])),
			productIcon12: await getProductIcon(safeUrl(products[12])),
			productIcon13: await getProductIcon(safeUrl(products[13])),
			productIcon14: await getProductIcon(safeUrl(products[14])),
			productIcon15: await getProductIcon(safeUrl(products[15])),
			productIcon16: await getProductIcon(safeUrl(products[16])),
			productIcon17: await getProductIcon(safeUrl(products[17])),
			productIcon18: await getProductIcon(safeUrl(products[18])),
			productIcon19: await getProductIcon(safeUrl(products[19])),
			
  		}
  	
  }


  pdfMake.createPdf(documentDefinition).download('My EdTech Index Shortlist.pdf');

}

function safeUrl(product){
	return !!product?(!!product.image_url?product.image_url:null):null
}
